import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import LiveAction from 'v-component/smart/live-action.vue';
import LiveAbnormal from 'v-component/smart/live-abnormal.vue';

import {withDefaults} from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    info: { default: null }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LiveAbnormal, {
      text: "直播已结束，感谢观看",
      icon: "end"
    }),
    _createVNode(LiveAction)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})